@for (column of columns(); track column) {
    <td class="custom-table-td">
        @switch (column.field) {
            @case (dashboardResultsColumnEnum.ORDER_NAME) {
                <div>
                    <a
                        [routerLink]="orderAbstractRoute()"
                        tooltipFocusHandler
                        (click)="logOrderNameClick()"
                        (keydown.enter)="logOrderNameClick()">
                        <app-ellipsis-tooltip
                            [paragraphId]="'result-order-name-' + result().orderId"
                            [isElementFocusable]="false">
                            {{ result().orderName }}
                        </app-ellipsis-tooltip>
                    </a>
                </div>
            }

            @case (dashboardResultsColumnEnum.NUMBER_OF_REACTIONS) {
                <div class="center-td-content">
                    <p [id]="'result-number-of-reactions-' + result().orderId">
                        {{ result().numberOfReactions }}
                    </p>
                </div>
            }

            @case (dashboardResultsColumnEnum.RESULTED) {
                <div class="center-td-content">
                    <p [id]="'result-date-resulted-' + result().orderId">
                        {{ result().resulted ? (result().resulted | date: 'MM/dd/YYYY | HH:mm:ss') : '-' }}
                    </p>
                </div>
            }

            @case (dashboardResultsColumnEnum.DOWNLOAD) {
                <div class="center-td-content">
                    @if (result().displayDownload) {
                        <div class="action-buttons-container">
                            <p-button
                                class="download-button"
                                [outlined]="true"
                                [disabled]="isDownloadingResult()"
                                [loading]="isDownloadingResult()"
                                (onClick)="downloadResults()"
                                size="small">
                                {{ fileExtensionEnum.AB1 + ' & ' + fileExtensionEnum.SEQ }}
                            </p-button>
                        </div>
                    } @else {
                        <div>-</div>
                    }
                </div>
            }
        }
    </td>
}
